import * as t from './actionTypes';
import * as api from './api';

export function saveNotification(data) {

    return (dispatch) => {
        dispatch({ type: t.NOTIFICATION_SET_BUSY });

      api.saveNotification(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.NEW_NOTIFICATION_SAVED, notification: data});
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
            } else if (error) {
                console.err(error);
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
            }
        })


    }
}

export function loadNotifications(successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.NOTIFICATION_SET_BUSY });

        api.loadNotifications(function (success, notifies, error) {
            if (success) {
                dispatch({ type: t.NOTIFICATION_LOAD_SUCCESS, notifications: notifies});
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function editNotification(id, data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.NOTIFICATION_SET_BUSY });

        api.editNotification(id, data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.NOTIFICATION_EDIT_SUCCESS, id: id, notification: data });
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function deleteNotification(id, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.NOTIFICATION_SET_BUSY });

        api.deleteNotification(id, function(success, error) {
            if (success) {
                dispatch({ type: t.NOTIFICATION_DELETE_SUCCESS, id: id });
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.NOTIFICATION_UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}
